import { render, staticRenderFns } from "./ParticipationCommentsItem.vue?vue&type=template&id=5438cbde&scoped=true"
import script from "./ParticipationCommentsItem.vue?vue&type=script&lang=js"
export * from "./ParticipationCommentsItem.vue?vue&type=script&lang=js"
import style0 from "./ParticipationCommentsItem.vue?vue&type=style&index=0&id=5438cbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438cbde",
  null
  
)

export default component.exports